import React from 'react';
import { Typography, Button, Card } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  portalContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  heading: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main, // You can use any color from the Material-UI theme

  },
  description: {
    marginBottom: theme.spacing(2),
  },
  exploreButton: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const ClientScreen = () => {
  const classes = useStyles();

  return (
    <div className={classes.portalContainer}>
     <Card style={{
        padding:20,
        backgroundColor: 'white',
     }}>
      <Typography variant="h4" className={classes.heading}>
        Welcome to the Candidates Portal at RecruitsPlus!
      </Typography>
      <Typography variant="body1" className={classes.description}>
        Embark on an incredible journey with thousands of worldwide job opportunities awaiting you. At RecruitsPlus, we are
        devoted to connecting you with the finest organizations across the globe.
      </Typography>
      <Typography variant="body1" className={classes.description}>
        The Candidate Portal empowers you to explore a diverse range of positions, spanning various industries and locations. Our
        platform offers you a seamless experience in finding top-tier job opportunities, each with the skills and expertise you have.
      </Typography>
      <Typography variant="body1" className={classes.description}>
        With RecruitsPlus by your side, you have access to a vast network of potential jobs, meticulously screened to
        ensure they meet your unique requirements. Let us help you to find job opportunities to drive success.
      </Typography>
    </Card>
    </div>
  );
};

export default ClientScreen;
